import React, { useCallback, useState } from 'react'
import { connect } from 'react-redux'
import { useDropzone } from 'react-dropzone'
import LinearProgress from '@material-ui/core/LinearProgress'
import classnames from 'classnames'
import { useLocalization } from 'decorators'
import { Icon } from 'components/icons'
import { actionCreators } from 'store/modules/dropzone'
import { useStyles } from './dropzone.css'

export const Dropzone = connect(
  ({ dropzone }) => ({ dropzone }),
  { uploadFile: actionCreators.uploadFile })(({ uploadButtonText, fullWidth, onFileUploaded, dropzone, uploadFile, ...dropZoneProps }) => {
  const { localize } = useLocalization()
  const classes = useStyles()
  const [active, setActive] = useState(false)

  const className = classnames({ [classes.active]: active }, classes.root)
  const onDragEnter = useCallback((e) => {
    e.stopPropagation()
    setActive(true)
  }, [])

  const onDragLeave = useCallback((e) => {
    e.stopPropagation()
    setActive(false)
  }, [])
  const onDragOver = useCallback((e) => {
    e.stopPropagation()
  }, [])
  const onDrop = useCallback((files) => uploadFile(files, onFileUploaded), [onFileUploaded, uploadFile])

  const { getRootProps, getInputProps } = useDropzone({ onDragEnter, onDragLeave, onDragOver, onDrop, ...dropZoneProps })
  const rootProps = getRootProps()
  const inputProps = getInputProps()
  return (
    <section className={fullWidth && classes.fullWidth}>
      <div {...rootProps} className={className}>
        {dropzone.uploading && <LinearProgress variant='determinate' value={dropzone.progress} />}
        <input {...inputProps} disabled={dropzone.uploading} />
        <div className={classes.clickArea}>
          <div><Icon name='cloud-upload' /></div>
          <div>{localize(uploadButtonText || 'dropzone.dragAndDropFile')}</div>
        </div>
      </div>
    </section>
  )
})
